export default {
  /**
   * Returns the configurator host based on the current window location.
   * @returns {string} The configurator host URL.
   */
  getConfiguratorHost() {
    if (
      window.location.host.toLowerCase() === 'sigflo.com' ||
      window.location.host.toLowerCase() === 'www.sigflo.com'
    ) {
      return 'https://configurator.sigflo.com';
    } else if (window.location.host.toLowerCase() === 'dev.sigflo.com') {
      return 'https://devconfig.sigflo.com';
    } else {
      return 'https://localhost:8080';
    }
  }
};
